import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Styled } from './styles';
import type { ColoredCardColor } from './types';

export type { ColoredCardColor } from './types';
type ColoredCardProps = {
  color: ColoredCardColor;
};
type DivProps = Omit<ComponentPropsWithoutRef<'div'>, keyof ColoredCardProps>;

type Props = DivProps & ColoredCardProps;

export const ColoredCard = forwardRef<HTMLDivElement, Props>(({ ...props }, ref) => (
  <Styled.Card {...props} ref={ref} />
));
ColoredCard.displayName = 'ColoredCard';
